/**
 * PostHog Feature Flag Keys
 * Central place for all PostHog feature flag constants
 *
 * Usage:
 *   import { FeatureFlagKeys } from '../constants/ff.posthog';
 *   const isEnabled = useFeatureFlag(FeatureFlagKeys.addDailyPayOption);
 */

export const FeatureFlagKeys = {
  addDailyPayOption: 'ARF-1866-add-daily-pay-option',
  credentialingV2: 'TEMP-13770-credentialing-v2',
  enablePermanentJobV2AdminPanel: 'ARF-30-enable-permanent-job-v2-admin-panel',
  bestInDentalAdminPanel: 'GOTU-5623-best-in-dental-admin-panel',
  blockAddChildToOfficeWithCompletedShifts:
    'GOTU-4592-block-add-child-to-office-with-completed-shifts',
  dsoManagersFromAuthService: 'GOTU-6387-dso-managers-from-auth-service',
  recruitersFromAuthService: 'GOTU-6388-recruiters-from-auth-service',
};
